module.exports = __webpack_public_path__ + "img/10.eae1307b.jpg";